export default __webpack_public_path__ + "static/media/Marianopolis.00fae185.webp";